import { __extends } from "tslib";
import React from 'react';
import { TooltipHelper } from './TooltipHelper';
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip(props) {
        var _this = _super.call(this, props) || this;
        _this.divRef = React.createRef();
        _this.contentRef = React.createRef();
        _this.onMouseEnter = _this.onMouseEnter.bind(_this);
        _this.onMouseLeave = _this.onMouseLeave.bind(_this);
        return _this;
    }
    Tooltip.prototype.componentWillUnmount = function () {
        TooltipHelper.hideTooltip();
    };
    Tooltip.prototype.onMouseEnter = function (e) {
        if (this.divRef.current && this.contentRef.current) {
            TooltipHelper.showTooltip(this.divRef.current, this.contentRef.current.innerHTML, true, this.props.alignment, this.props.position, this.props.className);
        }
    };
    Tooltip.prototype.onMouseLeave = function (e) {
        TooltipHelper.hideTooltip();
    };
    Tooltip.prototype.render = function () {
        return React.createElement("div", { ref: this.divRef, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, style: { display: this.props.inline ? "inline-block" : "" } },
            React.createElement("div", { style: { display: "none" }, ref: this.contentRef }, this.props.content),
            this.props.children);
    };
    Tooltip.fromDataAttributes = function (element, attributes) {
        if (attributes["data-tip"]) {
            return React.createElement(Tooltip, { content: attributes["data-tip"], className: attributes["data-tip-class"], alignment: attributes["data-tip-align"], position: attributes["data-tip-pos"] }, element);
        }
        else {
            return element;
        }
    };
    Tooltip.setDomProperties = function (dom, tooltipOptions) {
        if (typeof tooltipOptions === "string") {
            dom["data-tip"] = tooltipOptions;
        }
        else {
            dom["data-tip"] = tooltipOptions.content;
            dom["data-tip-class"] = tooltipOptions.className;
            dom["data-tip-align"] = tooltipOptions.alignment;
            dom["data-tip-pos"] = tooltipOptions.position;
        }
    };
    return Tooltip;
}(React.Component));
export default Tooltip;
